import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Dropdown from "~/components/CasesDropdown.vue";
export default {
  __name: 'Hint',
  setup: function setup(__props) {
    var hintStore = useHintStore();
    var hydrated = computed(function () {
      return hintStore.hydrated;
    });
    var ddName = computed(function () {
      return hintStore.ddName;
    });
    var anchorId = computed(function () {
      return hintStore.clone && hintStore.clone.id;
    });
    var placement = computed(function () {
      return hintStore.placement;
    });
    var fallbackPlacements = computed(function () {
      return hintStore.fallbackPlacements;
    });
    var hint = computed(function () {
      return hintStore.hint;
    });
    var closedHints = computed(function () {
      return hintStore.closedHints;
    });
    var Template = computed(function () {
      if (!hint.value) return null; // TODO: create skeleton template
      return function () {
        return import("./".concat(hint.value, ".vue"));
      };
    });
    function close() {
      hintStore.close(hint.value);
    }
    onMounted(function () {
      hintStore.hydrate();
    });

    // Emit event for all hints;
    watch(hydrated, function (newVal) {
      if (!newVal) return;
      var event = new Event("hintsHydrated");
      window.dispatchEvent(event);
    });
    watch(closedHints, function (newVal) {
      var event = new CustomEvent("hintsUpdated", {
        detail: newVal
      });
      window.dispatchEvent(event);
    });
    return {
      __sfc: true,
      hintStore: hintStore,
      hydrated: hydrated,
      ddName: ddName,
      anchorId: anchorId,
      placement: placement,
      fallbackPlacements: fallbackPlacements,
      hint: hint,
      closedHints: closedHints,
      Template: Template,
      close: close,
      Dropdown: Dropdown
    };
  }
};